import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStore, faTruck } from '@fortawesome/free-solid-svg-icons';

const tarjetaOrden = ({ col, claseEstado, claseTipo, claseApoyo, item, onClick, seleccionado }) => {

    const _claseEstado = `orden-button ${seleccionado ? 'selected' : ''} ${claseEstado}`;

    return (
        <div className={"col-" + col}>
            <div className={_claseEstado} onClick={() => { onClick(item) }}>
                <div className="orden-identificador">
                    <span className="number">{"#" + item.Orden_Id}</span>
                    <span>{
                        claseTipo === "PU" ?
                            <FontAwesomeIcon icon={faStore} /> :
                            <FontAwesomeIcon icon={faTruck} />
                    }</span>
                    <p>{item.tiempo}</p>
                </div>
                <div className="orden-cliente">
                    <strong>{item.fechaStr}</strong>
                    <p title={item.Cliente_Nombre} className="p-card-name">{item.Cliente_Nombre}</p>
                    <div className="row no-gutters">
                        <div className="col">
                            <span className="ecom-number">{(item.Ecommerce ? item.Ubicacion_Id : "")}</span>
                        </div>
                        <div className="col">
                            <span className="suc-apoy"><i className={claseApoyo}></i></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default tarjetaOrden;